import { Injectable } from "@angular/core";
import { QueryStringSerializationService } from "../../../../shared-library/services/environment/query-string-serialization.service";

import { SearchParametersModel } from "../models/search-parameters.model";

@Injectable({
    providedIn: "root"
})
export class DirectorySearchParametersFactoryService {
    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public createFromQueryString(queryString: string): SearchParametersModel {
        const rawValues = this._serializationService.deserializeToType<SearchParametersModel>(queryString);
        return this.createFromObject(rawValues);
    }

    public createFromObject(rawValues: {[key: string]: any}): SearchParametersModel {
        const parsedValues = new SearchParametersModel();

        parsedValues.searchText = (rawValues.searchText as string || "").replace(/(\+)+/gi, " ").trim();
        parsedValues.pageNumber = (rawValues.pageNumber > 0) ? Number(rawValues.pageNumber) : 1;
        parsedValues.pageSize = ((rawValues.pageSize > 0) && (rawValues.pageSize <= 100)) ? Number(rawValues.pageSize) : 15;
        parsedValues.sortOption = rawValues.sortOption || (!!rawValues.searchText ? "Rank;asc" : "Name;asc");
        parsedValues.categories = rawValues.categories || [];
        parsedValues.categories = rawValues.categories ?? [];
        parsedValues.templateId = rawValues.templateId || "";
        parsedValues.attributeIds = rawValues.attributeIds ?? [];
        parsedValues.locationIds = rawValues.locationIds ?? [];

        return parsedValues;
    }

    public serialiseToQueryString(searchParams: SearchParametersModel): string {
        return this._serializationService.serialize(searchParams);
    }
}
